module.exports = __webpack_public_path__ + "fonts/MyriadPro-Cond.32953d03.otf";